import api from "./api";

export const reportApi = {
  dashboard: (query = "") => api.get(`/reports/dashboard${query}`),
  exportCsv: (query = "") =>
    api.get(`/reports/export${query}`, { responseType: "blob" }),
};